import React, { Fragment } from 'react';
import { DateTime } from 'luxon';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Eyebrow from '../eyebrow';

// Config.
import { GRANTS_SHAPE } from '../../../config/prop-types';

// Components.
import SafeHTML from '../safe-html';

// Images.
import iconCaret from '../../images/icon-caret.png';

// Styles.
import './grantsItem.scss';

/**
 * Grants App - Item component.
 */
export default class GrantsItem extends React.PureComponent {
  /**
   * Start the component
   */
  constructor(props) {
    super(props);
    const {
      grant,
      initialGrantSlug,
    } = props;
    const isActive = initialGrantSlug === grant.slug;
    this.state = {
      initialGrantSlug,
      visible: isActive,
    };
    this.toggleGrantVisibility = this
      .toggleGrantVisibility.bind(this);
  }

  /**
   * Toggle open and closed the filter item.
   */
  toggleGrantVisibility(grant) {
    const {
      clickHandler,
    } = this.props;
    const {
      visible,
    } = this.state;
    this.setState((prevState) => ({
      visible: ! prevState.visible,
    }), () => {
      clickHandler(grant, visible);
    });
  }
  /**
   * Renders this component.
   * @returns {object} Component markup.
   */
  render() {
    const {
      grant,
    } = this.props;
    const {
      initialGrantSlug,
      visible,
    } = this.state;
    const eyebrow = 0 !== grant.programs.length ? grant.programs[0] : false;

    const grantStartDate = DateTime.fromISO(grant.started_on);
    const grantDescription = grant.description;
    const grantSlug = grant.slug;
    return (
      <div
        className={classnames(
          'grants__item',
          'grants-item',
          grantSlug === initialGrantSlug && 'grants-item--type--priority',
          grantSlug && `grants-item--slug--${grantSlug}`,
        )}
        aria-expanded={visible}
      >
        <button
          className="grants-item__toggler"
          onClick={() => this.toggleGrantVisibility(grant)}
        >
          <span
            className={classnames(
              'grants__icon',
              'grants-item__icon',
            )}
          >
            <img src={iconCaret} alt="" />
          </span>

        </button>
        {/* The grant cards use the grantee as the title. */}
        {/* Grant Grantee Name */}
        {grant.grantees && (
          <button
            className="grants-item__name"
            onClick={() => this.toggleGrantVisibility(grant)}
          >
            <Eyebrow label={eyebrow.name} color={eyebrow.theme_color} />
            <div className="grants-item__title-wrapper">
              <span className="grants-item__grant_name">
                {grant.grantees.map((grantee, i) => (
                  <Fragment key={grantee}>
                    {0 < i && ', '}
                    <SafeHTML
                      html={grantee.post_title}
                      tag="span"
                    />
                  </Fragment>
                ))}
              </span>
              {0 < grant.amount && (
                <span
                  className="grants-item__amount"
                >
                  {parseFloat(grant.amount).toLocaleString()}
                </span>
              )}
            </div>

          </button>
        )}
        {grantDescription && (
          <SafeHTML
            className="grants-item__description"
            html={`<span class="grants-item__detail-label">Goal: </span>${grantDescription}`} // eslint-disable-line max-len
            tag="div"
          />
        )}
        <div className="grants-item__detail-wrapper">
          {/* Granted date */}
          {grantStartDate.isValid && (
            <div className="started_on grants-item__detail">
              <span className="grants-item__detail-label">
                Year Granted:
              </span>
              <span>
                {grantStartDate.year}
              </span>
            </div>
          )}
          {/* Amount */}
          {0 < grant.amount && (
            <div className="amount grants-item__detail">
              <span className="grants-item__detail-label">
                Amount:
              </span>
              <span>
                {`$${parseFloat(grant.amount).toLocaleString()}`}
              </span>
            </div>
          )}
          {/* Communities */}
          {0 !== grant.communities.length && (
            <div className="grants-item__detail">
              <span className="grants-item__detail-label">
                {`${1 < grant.communities.length
                  ? 'Communities:' : 'Community:'}`}
              </span>
              {grant.communities.map((community, i) => (
                <Fragment key={community}>
                  {0 < i && ', '}
                  <SafeHTML
                    html={community}
                    tag="span"
                  />
                </Fragment>
              ))}
            </div>
          )}
          {/* Challenges */}
          {0 !== grant.challenges.length && (
            <div className="grants-item__detail">
              <span className="grants-item__detail-label">
                {`${1 < grant.challenges.length
                  ? 'Challenges:' : 'Challenge:'}`}
              </span>
              {grant.challenges.map((challenge, i) => (
                <Fragment key={challenge}>
                  {0 < i && ', '}
                  <SafeHTML
                    html={challenge}
                    tag="span"
                  />
                </Fragment>
              ))}
            </div>
          )}
          {/* Focus Areas */}
          {0 !== grant.programs.length && (
            <div className="grants-item__detail">
              <span className="grants-item__detail-label">
                {`${1 < grant.programs.length
                  ? 'Programs:' : 'Program:'}`}
              </span>
              {grant.programs.map((program, i) => (
                <Fragment key={program.name}>
                  {0 < i && ', '}
                  <SafeHTML
                    html={program.name}
                    tag="span"
                  />
                </Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

GrantsItem.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  grant: PropTypes.shape(GRANTS_SHAPE).isRequired,
  initialGrantSlug: PropTypes.string.isRequired,
};
